export enum FORM {
  CREATE_AYUMI = 'CREATE_AYUMI',
  UPDATE_AYUMI = 'UPDATE_AYUMI',
}

export enum AYUMI_TAB {
  KNOW = 'KNOW',
  PREPARE = 'PREPARE',
}

export const AYUMI_TAB_LABELS: Record<AYUMI_TAB, string> = {
  [AYUMI_TAB.KNOW]: '課題を知る',
  [AYUMI_TAB.PREPARE]: 'そなえる',
};

/** 図表画像の想定幅。Figma の指定に合わせる */
export const KNOW_IMAGE_WIDTH = 604;

export const MAX_LENGTH = {
  SUMMARY: 200,
  KNOW_TITLE: 200,
  VIDEO_URL: 500,
  CATEGORY_NAME: 100,
  ITEM_TITLE: 200,
};
